import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { Label } from 'components'

import useDataProcess from 'hooks/useDataProcess'
import { isEmpty } from 'lodash'

import useStyles from '../../styles'
import { DialogPermanentStorageAlert } from 'views/DataProcesses/components'

const Laws = ({ laws, setLaws }) => {
  const classes = useStyles()
  const { laws: lawsOptions } = useDataProcess()

  const [openAlertDialog, setOpenAlertDialog] = useState(false)

  const handleChangeAlertDialog = () => {
    setOpenAlertDialog((open) => !open)
  }

  const selectedLaws = (lawsOptions ?? []).filter((opt) =>
    laws.includes(opt.id),
  )

  return (
    <>
      <Box className={classes.box}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label
              title="Motivo"
              description="Qual lei que obriga fazer o armazenamento permanente?"
              item
              xs={12}
            >
              <Autocomplete
                multiple
                options={lawsOptions ?? []}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) =>
                  option.id === value.id || value.id === 0
                }
                value={selectedLaws}
                onChange={(_, newValue) => setLaws(newValue.map((v) => v.id))}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Motivo"
                    error={isEmpty(laws)}
                    InputProps={{ ...params.InputProps }}
                    fullWidth
                  />
                )}
              />
              <Typography variant="caption" color="secondary">
                Não encontrou a justificativa adequada?{' '}
                <span
                  onClick={handleChangeAlertDialog}
                  className={classes.link}
                >
                  Clique aqui
                </span>{' '}
                e contate nosso especialista!
              </Typography>
            </Label>
          </Grid>
        </Grid>
      </Box>
      <DialogPermanentStorageAlert
        open={openAlertDialog}
        setOpen={setOpenAlertDialog}
        title="Atenção!"
        subtitle="Você tem certeza da necessidade de armazenamento permanente destes dados? Uma das boas práticas em privacidade e proteção de dados é que os dados pessoais sejam eliminados após o término de seu tratamento"
      />
    </>
  )
}

Laws.propTypes = {
  laws: PropTypes.object.isRequired,
  setLaws: PropTypes.isRequired,
}

export default Laws
